/* =========================

  which is name

============================ */
// import styled from "styled-components";
// import {break_point_sp} from "./components/cssBasic/mixin";

import Header from "../../Components/Header/index";

import { Outlet,useLocation,useNavigate } from 'react-router-dom';
import { useEffect } from 'react';


/* -------------------------

  component

---------------------------- */
function Results( props ) {

  // /resultの親に接続されたらリダイレクト
  const location = useLocation();
  let navigate = useNavigate();
  let state = location.pathname;
  useEffect(() => {
    if(state.split("/")[2] === "" || state.split("/").length <= 2){
      navigate(`/`)
    }
  },[state,navigate]);
  useEffect(() => {
    document.querySelector("#footer_contents").style.display="block";
  }, []);

  return (
    <>
      <Header/>

      <Outlet/>

    </>
  );
}

export default Results;

/* -------------------------

  styled

---------------------------- */
// const Styled = styled.div`
// 	@media ${break_point_sp} {
// 	}
// `;
